# Patches older Vuetify components that don't meet modern table th requirements.
# On v-date-picker, also labels weekday headers with full day names.
DAYS = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday']

setAttr = (el, name, value) ->
  el.setAttribute name, value unless el.getAttribute(name) is value
  return

datePickerOf = (vnode) ->
  vm = vnode.componentInstance
  if vm?.$options.name is 'v-date-picker' then vm else null

apply = (el, vnode) ->
  el.querySelectorAll('th').forEach (th) ->
    setAttr th, 'scope', 'col'

  if picker = datePickerOf vnode
    first = parseInt(picker.firstDayOfWeek, 10) or 0
    el.querySelectorAll('.v-date-picker-table--date thead th').forEach (th, i) ->
      longday = DAYS[(i + first) % 7]
      setAttr th, 'abbr', longday
      setAttr th, 'aria-label', longday
  return

export default
  inserted: (el, binding, vnode) ->
    el._thScopeVnode = vnode
    apply el, vnode
    el._thScopeObserver = new MutationObserver -> apply el, el._thScopeVnode
    el._thScopeObserver.observe el, childList: true, subtree: true
    return

  componentUpdated: (el, binding, vnode) ->
    el._thScopeVnode = vnode
    apply el, vnode
    return

  unbind: (el) ->
    el._thScopeObserver?.disconnect()
    delete el._thScopeObserver
    delete el._thScopeVnode
    return